import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { RowSettings } from './RowSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'

export const defaultProps = {
  direction: '',
}

export const dynamicProps = []

export const Row: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }
    const { direction } = blockProps

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-row ${direction ? `block-row--${direction}` : ''} ${props.className}`}
      >
        {React.Children.toArray(children).filter((child) => !child.props.hidden)}
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

Row.craft = withCraft({
  name: 'Row',
  defaultProps: defaultProps,
  settings: RowSettings,
})
